<script setup lang="ts">
import { formatList } from "~/utilities/format"

const products = useProductVariantsStore()

const releasedGroupedProductVariants = computed(() => {
  return Object.values(products.groupedProductVariants ?? {})
    .filter(product => product.variants.some(variant => variant.ean))
    .sort((a, b) => {
      return a.productTitle.localeCompare(b.productTitle)
    })
})

const router = useRouter()
</script>

<template>
  <div
    class="mb-20 flex w-full flex-wrap items-start justify-start gap-6"
  >
    <div
      v-for="product in releasedGroupedProductVariants"
      :key="product.productTitle"
      class="w-full"
    >
      <div
        class="flex w-full max-w-[100em] flex-col items-center justify-center gap-10 rounded-2xl bg-platform-white p-10 drop-shadow-xl lg:flex-row"
      >
        <img
          v-if="product.variants[0].eCommerce?.imageUrl"
          :src="product.variants[0].eCommerce?.imageUrl"
          class="w-full cursor-pointer rounded-2xl object-contain p-4 lg:w-[320px]"
          :class="`bg-${product.theme}-lightest`"
          :alt="
            product.variants[0].eCommerce?.imageDescription ||
            `Produktillustrasjon for ${product.productTitle} `
          "
          @click="
            product.hasAtLeastOneReleasedProduct &&
              router.push(
                `/produkter/${product.productTitle
                  .replaceAll(' ', '-')
                  .toLowerCase()}`,
              )
          "
        />
        <div class="flex w-full flex-col gap-4">
          <h4
            class="font-national2 text-2xl font-extrabold leading-8 text-[--theme-dark]"
          >
            Dekker pensum på
            {{ formatList(product.productCurriculumFor) }}
          </h4>
          <h3
            class="font-national2compressed text-5xl font-extrabold uppercase leading-10"
            :class="`text-${product.theme}-dark`"
          >
            Kunne
            <span v-html="product.productTitleHtml" />
            {{
              !product.productTitleHtml ? product.productTitle : null
            }}
          </h3>
          <p v-html="product.groupSalesPitch" />
          <p
            v-if="!product.hasAtLeastOneReleasedProduct"
            class="font-national2 text-xl font-extrabold leading-8 text-[--theme-darkest]"
          >
            Kommer snart
          </p>

          <div class="flex gap-4">
            <UButtonNew
              :to="`/produkter/${product.urlFormatProductTitle}`"
              bold
            >
              Les mer
              <span class="sr-only"
                >om Kunne {{ product.productTitle }}</span
              >
            </UButtonNew>
            <UButtonNew
              v-if="
                product.hasAtLeastOneReleasedProduct &&
                product.variants.some(v => !v.isFree)
              "
              data-pendo="forside-kjop-tilgang"
              variant="filled"
              theme="cta"
              pill
              :to="`/produkter/${product.urlFormatProductTitle}/betaling`"
            >
              Kjøp
              <span class="hidden md:inline">tilgang</span>
              <span class="sr-only"
                >til Kunne {{ product.productTitle }}</span
              ></UButtonNew
            >
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
